import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api/api'; // Import your axios instance

// Create an async thunk for the API call
export const fetchAttempts = createAsyncThunk(
    'attempts/fetchAttempts',
    async (queryParams, { rejectWithValue }) => {
        try {
            const response = await api.get('/assessment/get_results/', {
                params: queryParams  // Pass queryParams as the params for the API request
            });  // Using your Axios instance for API call
            return response.data;  // Return the data on success
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error.message);
        }
    }
);

// Define the initial state of the slice
const initialState = {
    data: {},
    loading: true,
    error: null,
};

// Create the slice
const attemptsSlice = createSlice({
    name: 'attempts',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAttempts.pending, (state) => {
                state.loading = true;  // Set loading to true when the API call is in progress
            })
            .addCase(fetchAttempts.fulfilled, (state, action) => {
                state.loading = false;  // Set loading to false when API call is successful
                state.data = action.payload;  // Store fetched users in state
            })
            .addCase(fetchAttempts.rejected, (state, action) => {
                state.loading = false;  // Set loading to false when API call fails
                state.error = action.payload;  // Store error in state
            })
    }
});

export default attemptsSlice.reducer;
